import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

interface Section {
  title: string;
  description: string;
}

@Component({
  selector: 'app-technology-consulting',
  templateUrl: './technology-consulting.component.html',
  styleUrls: ['./technology-consulting.component.css'],
  standalone: false
})
export class TechnologyConsultingComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | Consultoría Tecnológica');
  }

  sections: Section[] = [
    {
      title: 'PLANES ESTRATÉGICOS Y NEGOCIO DIGITAL',
      description: 'Desde el planteamiento del proyecto hasta su seguimiento y control, desarrollamos planes estratégicos especializados para las diferente situaciones de la empresa implementando medidas que optimicen su rendimiento.'
    },
    {
      title: 'ESTUDIOS DE MERCADO',
      description: 'Analizamos la industria de tu empresa y los diversos proveedores de herramientas digitales para ofrecer al cliente aquella solución que mejor se adapta a las necesidades de la organización.'
    },
    {
      title: 'SOLUCIÓN',
      description: 'Sabemos que la transformación de la empresa hacia un entorno digital supone grandes cambios en la organización y por ello, ayudamos a la misma a definir sus objetivos y dirigir sus acciones hacia el camino adecuado.'
    },
    {
      title: 'CONTROL DE CALIDAD (QA)',
      description: 'Acompañamos al cliente en la definición de procesos de QA y pruebas, garantizando que los sistemas y aplicaciones implantados cumplan los estándares de fiabilidad y rendimiento exigidos por el negocio.'
    }
  ]

}
